import React, { Component } from 'react';
import { connect } from 'react-redux';
import './App.css';
import Layout from './components/Shared/Layout';
import Login from './components/Authentication/login';
import ForgotPassword from './components/Authentication/forgotpassword';
import ResetPassword from './components/Authentication/resetpassword';
import NotFound from './components/Authentication/404';
import Maintenance from './components/Authentication/maintenance';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import * as jwtService from './services/jwt.service';
import UnAuthorized from "./components/Errors/403";
import "react-toastify/dist/ReactToastify.css";

class App extends Component {

	render() {
		const { themeColor, fontStyle, lightVersion, RtlVersion, offcanvas, miniSidebar, horizontalMenu, miniHover, user } = this.props
		document.getElementsByTagName('body')[0].className = `${themeColor} ${fontStyle}${lightVersion ? ' light_version' : ''}${RtlVersion ? ' rtl' : ''}${offcanvas ? ' offcanvas-active' : ''}${horizontalMenu ? ' h-menu' : ''}${miniSidebar ? ' mini_sidebar' : ''}${miniHover ? ' mini_hover' : ''}`;
		return (
			<div
				ref={leftSidebar => {
					this.leftSidebar = leftSidebar;
				}}
			>
				<Router>
					<Switch>
						<Route path="/login" component={Login} />
						<Route path="/forgotpassword" component={ForgotPassword} />
						<Route path="/reset-password" component={ResetPassword} />
						<Route path="/notfound" component={NotFound} />
						<Route path="/unauthorize" component={UnAuthorized} />
						<Route path="/maintenance" component={Maintenance} />
						<Route render={(props) => (user) ? (
							<Layout {...props} />
						) : (
							<Redirect to="login" />
						)} />
						<Route path="*">
							<NotFound />
						</Route>
					</Switch>
				</Router>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	themeColor: state.settings.themeColor,
	fontStyle: state.settings.fontStyle,
	lightVersion: state.settings.lightVersion,
	RtlVersion: state.settings.RtlVersion,
	offcanvas: state.settings.offcanvas,
	horizontalMenu: state.settings.horizontalMenu,
	miniSidebar: state.settings.miniSidebar,
	miniHover: state.settings.miniHover,
	user: state.auth.user
})

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(App)